/** Account settings — profile, security, and workspace preferences. */
export const moduleConfig = {
  module: {
    title: 'Account settings',
    description: 'Profile, security, and workspace preferences',
    route: {
      list: '/account-settings',
      path: '/account-settings',
    },
  },
};

export default moduleConfig;
